import React from "react";

/* eslint-disable react/display-name */
export default React.memo(() => {
    return (
        <svg
            width="22"
            height="16"
            viewBox="0 0 22 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.30192 8C7.30192 9.97809 8.95792 11.5811 11 11.5811C13.042 11.5811 14.698 9.97809 14.698 8C14.698 6.0219 13.042 4.4189 11 4.4189C8.95792 4.4189 7.30192 6.0219 7.30192 8ZM12.7784 8C12.7784 8.95029 11.9827 9.72157 11 9.72157C10.0172 9.72157 9.22155 8.95029 9.22155 8C9.22155 7.04971 10.0172 6.27842 11 6.27842C11.9827 6.27842 12.7784 7.04971 12.7784 8Z"
                fill="#1D1D1B"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.823933 9.6093C1.40598 10.4819 2.09284 11.3542 2.88388 12.1712C5.18629 14.5491 7.89859 16 11 16C14.1014 16 16.8137 14.5491 19.1161 12.1712C19.9072 11.3542 20.594 10.4819 21.1761 9.6093C21.5276 9.08229 21.7693 8.66629 21.8986 8.41595C22.0338 8.15411 22.0338 7.84589 21.8986 7.58405C21.7693 7.33371 21.5276 6.91771 21.1761 6.3907C20.594 5.51806 19.9072 4.64583 19.1161 3.82883C16.8137 1.45086 14.1014 0 11 0C7.89859 0 5.18629 1.45086 2.88388 3.82883C2.09284 4.64583 1.40598 5.51806 0.823933 6.3907C0.472422 6.91771 0.230678 7.33371 0.101405 7.58405C-0.0338017 7.84589 -0.0338017 8.15411 0.101405 8.41594C0.230678 8.66629 0.472422 9.08229 0.823933 9.6093ZM2.43629 8.60015C2.29376 8.38646 2.16674 8.1853 2.05552 8C2.16674 7.8147 2.29376 7.61354 2.43629 7.39985C2.95952 6.61539 3.57761 5.83054 4.28403 5.10093C6.26047 3.05963 8.51125 1.85953 11 1.85953C13.4887 1.85953 15.7395 3.05963 17.716 5.10093C18.4224 5.83054 19.0405 6.61539 19.5637 7.39985C19.7062 7.61354 19.8333 7.8147 19.9445 8C19.8333 8.1853 19.7062 8.38646 19.5637 8.60015C19.0405 9.38461 18.4224 10.1695 17.716 10.8991C15.7395 12.9404 13.4887 14.1405 11 14.1405C8.51125 14.1405 6.26047 12.9404 4.28403 10.8991C3.57761 10.1695 2.95952 9.38461 2.43629 8.60015Z"
                fill="#1D1D1B"
            />
        </svg>
    );
});